import { Box } from '@mui/material';

import { COLORS } from '~/styles/colors';
import { getScalValue } from '~/utils/common';

type VCardPreviewAvatarProps = {
  avatar: string;
  borderRadius: number;
  scale: number;
  rotate: number;
};
export default function VCardPreviewAvatar({ avatar, borderRadius, scale, rotate }: VCardPreviewAvatarProps) {
  return (
    <Box
      sx={{
        backgroundColor: COLORS.white,
        borderRadius: !borderRadius ? '50%' : `${borderRadius}px`,
        transform: `scale(${getScalValue(scale)})`,
        alignItems: 'center',
        width: 78,
        height: 78,
        display: 'flex',
        justifyContent: 'center',
        padding: '4px',
      }}
    >
      <img
        src={avatar}
        alt="v-card image"
        style={{
          width: 70,
          height: 70,
          borderRadius: !borderRadius ? '50%' : borderRadius,
          objectFit: 'cover',
          transform: `rotate(${rotate}deg)`,
        }}
      />
    </Box>
  );
}
